import { render, staticRenderFns } from "./CalendarViewSwitch.vue?vue&type=template&id=620a6220&scoped=true&"
import script from "./CalendarViewSwitch.vue?vue&type=script&lang=ts&"
export * from "./CalendarViewSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarViewSwitch.vue?vue&type=style&index=0&id=620a6220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620a6220",
  null
  
)

export default component.exports